<!-- TradePasswordModal.vue -->
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :title="title"
    :width="width"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
    class="password-dialog"
    append-to-body
  >
    <div class="password-modal-content">
      <!-- 产品信息（可选） -->
      <div class="product-info" v-if="productInfo">
        <div class="product-info-bar">
          <img
            v-if="productInfo.img"
            :src="productInfo.img"
            alt=""
            class="product-flag"
          />
          <span class="product-name">{{ productInfo.name }}</span>
          <span class="product-price" v-if="productInfo.price">
            ${{ productInfo.price }}
          </span>
        </div>
      </div>

      <div class="password-input-area">
        <div class="password-label">
          <span class="label-icon">🔐</span>
          {{ labelText }}
        </div>

        <!-- 密码输入 -->
        <el-input
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="placeholder"
          size="large"
          @keyup.enter.native="handleConfirm"
          class="password-input"
          ref="passwordInput"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-view"
            @click="togglePasswordVisibility"
            style="cursor: pointer"
          ></i>
        </el-input>

        <!-- 错误信息 -->
        <div class="password-error" v-if="errorMessage">
          {{ errorMessage }}
        </div>

        <!-- 额外提示 -->
        <div class="password-hint" v-if="hint">
          {{ hint }}
        </div>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" :disabled="loading">
        {{ cancelText }}
      </el-button>
      <el-button
        type="primary"
        @click="handleConfirm"
        :loading="loading"
        :disabled="loading"
      >
        {{ confirmText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "TradePasswordModal",

  props: {
    // ===== 弹窗控制 =====
    visible: {
      type: Boolean,
      default: false,
    },

    // ===== 文本配置 =====
    title: {
      type: String,
      default: "交易确认",
    },
    labelText: {
      type: String,
      default: "请输入交易密码",
    },
    placeholder: {
      type: String,
      default: "请输入交易密码",
    },
    confirmText: {
      type: String,
      default: "确认支付",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    hint: {
      type: String,
      default: "",
    },

    // ===== 样式配置 =====
    width: {
      type: String,
      default: "420px",
    },

    // ===== 产品信息 =====
    productInfo: {
      type: Object,
      default: null,
      // { img: '', name: '', price: '' }
    },

    // ===== 加载状态 =====
    loading: {
      type: Boolean,
      default: false,
    },

    // ===== 错误信息（外部控制） =====
    error: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      password: "",
      showPassword: false,
      errorMessage: "",
      dialogVisible: false,
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.password = "";
          this.errorMessage = "";
          this.$nextTick(() => {
            this.$refs.passwordInput?.focus();
          });
        }
      },
    },

    error: {
      immediate: true,
      handler(val) {
        this.errorMessage = val;
      },
    },

    dialogVisible(val) {
      if (!val && this.visible) {
        this.$emit("update:visible", false);
        this.$emit("close");
      }
    },
  },

  methods: {
    // ===== 切换密码可见性 =====
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      this.$nextTick(() => {
        this.$refs.passwordInput?.focus();
      });
    },

    // ===== 确认 =====
    handleConfirm() {
      if (!this.password || this.password.trim() === "") {
        this.errorMessage = "请输入交易密码";
        this.$refs.passwordInput?.focus();
        return;
      }

      if (this.password.length < 6) {
        this.errorMessage = "交易密码长度不能少于6位";
        this.$refs.passwordInput?.focus();
        return;
      }

      this.errorMessage = "";
      this.$emit("confirm", this.password);
    },

    // ===== 取消 =====
    handleCancel() {
      this.password = "";
      this.errorMessage = "";
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$emit("close");
    },

    // ===== 关闭 =====
    handleClose() {
      this.password = "";
      this.errorMessage = "";
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.$emit("close");
    },

    // ===== 清空密码（外部调用） =====
    clearPassword() {
      this.password = "";
      this.errorMessage = "";
    },

    // ===== 设置错误信息（外部调用） =====
    setError(msg) {
      this.errorMessage = msg;
      this.$refs.passwordInput?.focus();
    },

    // ===== 聚焦输入框 =====
    focus() {
      this.$refs.passwordInput?.focus();
    },
  },
};
</script>

<style scoped>
.password-dialog >>> .el-dialog {
  background: #1a1e2e;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.password-dialog >>> .el-dialog__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 18px 24px;
}

.password-dialog >>> .el-dialog__title {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.password-dialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
}

.password-dialog >>> .el-dialog__headerbtn .el-dialog__close:hover {
  color: #fff;
}

.password-dialog >>> .el-dialog__body {
  padding: 20px 24px;
}

.password-dialog >>> .el-dialog__footer {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 14px 24px;
}

.password-modal-content {
  padding: 4px 0;
}

/* ===== 产品信息 ===== */
.product-info {
  margin-bottom: 18px;
}

.product-info-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: rgba(0, 180, 255, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(0, 180, 255, 0.08);
}

.product-flag {
  width: 28px;
  height: 20px;
  border-radius: 4px;
  object-fit: cover;
}

.product-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.product-price {
  font-size: 16px;
  font-weight: 700;
  color: #00b4ff;
  font-family: "SF Mono", "Courier New", monospace;
}

/* ===== 密码输入区 ===== */
.password-input-area {
  margin-top: 4px;
}

.password-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 10px;
}

.label-icon {
  font-size: 18px;
}

.password-input >>> .el-input__inner {
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #fff !important;
  height: 44px;
  font-size: 15px;
  letter-spacing: 2px;
}

.password-input >>> .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.2);
  letter-spacing: 0;
}

.password-input >>> .el-input__inner:focus {
  border-color: #00b4ff !important;
  box-shadow: 0 0 0 3px rgba(0, 180, 255, 0.15) !important;
}

.password-input >>> .el-input__suffix {
  color: rgba(255, 255, 255, 0.3);
}

.password-input >>> .el-input__suffix .el-input__icon {
  color: rgba(255, 255, 255, 0.3);
  font-size: 18px;
  transition: color 0.3s ease;
}

.password-input >>> .el-input__suffix .el-input__icon:hover {
  color: rgba(255, 255, 255, 0.7);
}

.password-error {
  color: #ff6b6b;
  font-size: 13px;
  margin-top: 8px;
  min-height: 20px;
  animation: shake 0.4s ease;
}

.password-hint {
  color: rgba(255, 255, 255, 0.2);
  font-size: 12px;
  margin-top: 8px;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-6px);
  }
  75% {
    transform: translateX(6px);
  }
}

/* ===== 底部按钮 ===== */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.password-dialog >>> .el-button--default {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.password-dialog >>> .el-button--default:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.password-dialog >>> .el-button--primary {
  background: linear-gradient(135deg, #00b4ff, #0066ff);
  border: none;
  padding: 10px 28px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.password-dialog >>> .el-button--primary:hover {
  opacity: 0.85;
  transform: translateY(-1px);
  box-shadow: 0 4px 20px rgba(0, 100, 255, 0.3);
}

.password-dialog >>> .el-button--primary.is-disabled {
  background: rgba(0, 100, 255, 0.4);
  border: none;
  opacity: 0.6;
}

.password-dialog >>> .el-button--primary.is-disabled:hover {
  transform: none;
  box-shadow: none;
}

/* ===== 响应式 ===== */
@media (max-width: 768px) {
  .password-dialog >>> .el-dialog {
    width: 92% !important;
  }

  .password-dialog >>> .el-dialog__body {
    padding: 16px 18px;
  }

  .password-dialog >>> .el-dialog__footer {
    padding: 12px 18px;
  }

  .product-info-bar {
    padding: 8px 12px;
  }

  .product-name {
    font-size: 13px;
  }

  .product-price {
    font-size: 14px;
  }

  .password-input >>> .el-input__inner {
    height: 40px;
    font-size: 14px;
  }

  .dialog-footer {
    flex-direction: column-reverse;
  }

  .dialog-footer .el-button {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .password-dialog >>> .el-dialog {
    width: 96% !important;
  }

  .password-dialog >>> .el-dialog__header {
    padding: 14px 16px;
  }

  .password-dialog >>> .el-dialog__title {
    font-size: 15px;
  }

  .password-dialog >>> .el-dialog__body {
    padding: 14px 16px;
  }

  .password-label {
    font-size: 13px;
  }

  .password-input >>> .el-input__inner {
    height: 38px;
    font-size: 13px;
  }
}
</style>
